import { MANAGE_PROJECT_TEAM_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"

import { useProjectPermissions } from "entities/projects/model/useProjectPermissions"
import { TeamRole } from "entities/team-members/types/TeamRole"

import { ProjectTeamScopedActionHandlers } from "../types/ProjectTeamActionHandlers"

export function useProjectTeamScopedActionHandlers({
  projectID
}: {
  projectID: string
}): ProjectTeamScopedActionHandlers {
  const { role } = useProjectPermissions({ projectID })
  const { openOverlay } = useOverlay(MANAGE_PROJECT_TEAM_OVERLAY)

  const manageTeam = useEvent(() => {
    openOverlay({
      projectID
    })
  })

  return {
    onManage: role === TeamRole.ADMIN ? manageTeam : undefined
  }
}
